import MobilePersonalRecommend from '@/pages/Mobile/PageComponents/PersonalRecommend';
import { Display } from '@/components/Display/Display';
const PersonalRecommend = (props) => {
    const { side = 'mobile', ...otherProps } = props;
    return (
        <>
            <Display show={side === 'mobile'}>
                <MobilePersonalRecommend {...otherProps}></MobilePersonalRecommend>
            </Display>
        </>
    );
};

export default PersonalRecommend;
